<!--
  - Copyright (c) 2020. Minerva Networks.
  - All rights reserved.
  -->

<template lang="html">
  <div class="lockedGlyph"
       @click="playVideoById({ id: id, fullscreen: fullscreen, offers, router:$router, ga })">
    <svg width="46px" height="46px" viewBox="0 0 46 46" version="1.1"
         xmlns="http://www.w3.org/2000/svg"
         xmlns:xlink="http://www.w3.org/1999/xlink">
      <desc>Gift</desc>
      <polygon id="Bkg" fill="#000000" points="0 0 46 0 0 46"></polygon>
      <polygon id="Gift" points="0 0 24 0 24 24 0 24"></polygon>
      <path
        d="M12.3036093,14.0700637 L7.34394904,14.0700637 L7.34394904,19.6751592 L12.3036093,19.6751592 L12.3036093,14.0700637 Z M13.6624204,14.0700637 L13.6624204,19.6751592 L18.656051,19.6751592 L18.656051,14.0700637 L13.6624204,14.0700637 Z M17.0877791,8.94055202 L20.3205945,8.94055202 C20.6942675,8.94055202 21,9.2462845 21,9.61995754 L21,13.3566879 C20.9660297,13.7303609 20.6602972,14.0360934 20.2866242,14.0360934 L19.9808917,14.0360934 L19.9808917,20.3205945 C19.9808917,20.6942675 19.6751592,21 19.3014862,21 L6.66454352,21 C6.29087049,21 5.985138,20.6942675 5.985138,20.3205945 L5.985138,14.0360934 L5.67940552,14.0360934 C5.30573248,14.0360934 5,13.7303609 5,13.3566879 L5,9.61995754 C5,9.2462845 5.30573248,8.94055202 5.67940552,8.94055202 L8.86024994,8.94055202 C8.52730148,8.52352512 8.32908705,7.9970809 8.32908705,7.44585987 C8.32908705,6.80042463 8.56687898,6.18895966 9.04246285,5.74734607 C9.48407643,5.30573248 10.0955414,5.03397028 10.7409766,5.03397028 C11.3864119,5.03397028 11.9978769,5.27176221 12.4394904,5.74734607 C12.6206209,5.92847651 12.8050932,6.17310194 12.9729922,6.45501827 C13.1461894,6.15878189 13.3381715,5.9017436 13.5265393,5.7133758 C13.9681529,5.27176221 14.5796178,5 15.2250531,5 C15.8704883,5 16.4819533,5.23779193 16.9235669,5.7133758 C17.3651805,6.15498938 17.6369427,6.76645435 17.6369427,7.4118896 C17.6369427,7.97818674 17.4538881,8.51833323 17.0877791,8.94055202 Z M6.32484076,12.6772824 L19.641189,12.6772824 L19.641189,10.2993631 L6.32484076,10.2993631 L6.32484076,12.6772824 Z M10.7409766,6.35881104 C10.4352442,6.35881104 10.1974522,6.46072187 9.99363057,6.66454352 C9.78980892,6.86836518 9.68789809,7.14012739 9.68789809,7.4118896 C9.68789809,7.6836518 9.78980892,7.95541401 9.99363057,8.15923567 C10.3673036,8.5329087 11.2505308,8.94055202 11.895966,8.94055202 C12.0997877,8.94055202 12.2016985,8.90658174 12.2356688,8.87261146 C12.2696391,8.83864119 12.3036093,8.70276008 12.3036093,8.5329087 C12.3036093,7.92144374 11.895966,7.03821656 11.522293,6.66454352 C11.3184713,6.46072187 11.0467091,6.35881104 10.7409766,6.35881104 Z M15.2250531,6.35881104 C14.9193206,6.35881104 14.6815287,6.46072187 14.477707,6.66454352 C14.0700637,7.03821656 13.6624204,7.92144374 13.6624204,8.5329087 C13.6624204,8.70276008 13.6963907,8.80467091 13.7303609,8.87261146 C13.7643312,8.90658174 13.866242,8.94055202 14.0700637,8.94055202 C14.7154989,8.94055202 15.5987261,8.5329087 15.9723992,8.15923567 C16.1762208,7.95541401 16.2781316,7.6836518 16.2781316,7.4118896 C16.2781316,7.14012739 16.1762208,6.86836518 15.9723992,6.66454352 C15.7685775,6.46072187 15.4968153,6.35881104 15.2250531,6.35881104 Z"
        id="Combined-Shape" :fill="colors.giftColor" fill-rule="nonzero"></path>
    </svg>
  </div>
</template>

<script lang="js">
import { mapActions, mapState } from 'vuex';

export default {
  name: 'locked-glyph',
  props: {
    id: {
      required: true,
    },
    fullscreen: {
      required: false,
      default: false,
    },
    offers: {
      required: false,
    },
    ga: {
      required: true,
    },
  },
  methods: {
    ...mapActions(['playVideoById']),
  },
  computed: {
    ...mapState(['colors']),
  },
};
</script>
